export class StringUtils {
    /**
     * Capitalize first letter for each word
     * @param string string to be capitalized
     * @returns captalized string
     */
    static capitalize(string: string) {
        return string
            .split(/\s+/)
            .map(
                word =>
                    word.charAt(0).toUpperCase() + word.slice(1).toLowerCase()
            )
            .join(' ');
    }

    /**
     * Remove HTML tags from string
     * @param string string to be cleaned
     * @returns cleaned string
     */
    static cleanHtmlString(string: string) {
        return string.replace(/(<([^>]+)>)/gi, '').trim();
    }

    /**
     * Remove accents from string and convert to lowercase
     * @param string string to be cleaned
     * @returns cleaned string
     */
    static removeAccents(string: string): string {
        return string
            .normalize('NFD')
            .replace(/[\u0300-\u036f]/g, '')
            .toLowerCase();
    }
}
